<ng-content select="elm-form-state-machine"></ng-content>

<div fxLayout fxLayoutAlign="center center"><ng-content select="mat-spinner"></ng-content></div>

<div fxLayout fxLayoutAlign="center center"><ng-content select="button"></ng-content></div>
